

import Component from 'generic.basecomponent';
import $ from 'jquery';
import app from 'app-instance';


export default class GiftAid extends Component {
    constructor(el) {
        super(el);
        this.donationAmountChange = this.donationAmountChange.bind(this);
        this.$container = $(this.container);
        this.$donation = this.$container.find('.js-gift-aid__donation');
        this.$increased = this.$container.find('.js-gift-aid__increased');
        this.currencySimbol = this.$container.attr('data-gift-aid-currency-symbol') || '';

        this.init();
    }

    init() {
        app.addListener('donateAmount:change', this.donationAmountChange);
        app.addListener('donateAmount:input', this.donationAmountChange);
    }

    donationAmountChange(value) {
        const donation = parseFloat(value) > 0 ? parseFloat(value) : 0;
        const donationVisual = donation.toFixed(2);
        const increasedVisual = (donation + donation * 0.25).toFixed(2);
        this.$donation.html(`${this.currencySimbol}${donationVisual}`);
        this.$increased.html(`${this.currencySimbol}${increasedVisual}`);

        if (donation > 0) {
            this.showContainer();
        } else {
            this.hideContainer();
        }
    }

    showContainer() {
        this.container.removeAttribute('hidden');
    }

    hideContainer() {
        this.container.setAttribute('hidden', '');
    }


    destroy() {
        super.destroy();
        app.removeListener('donateAmount:change', this.donationAmountChange);
        app.removeListener('donateAmount:input', this.donationAmountChange);
        this.$container.removeClass('js-gift-aid-inited');
    }
}



// WEBPACK FOOTER //
// ./app/components/gift-aid/js/generic.gift-aid.js